"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.days = void 0;
var days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
exports.days = days;